export class AppConstants {
  public static COMPENSATION_TYPE_ORDER: string = "order";
  public static COMPENSATION_TYPE_REIMBURSEMENT: string = "reimbursement";
  public static COMPENSATION_TYPE_RECLAMATION: string = "reclamation";
  public static COMPENSATION_TYPE_CANCELLATION: string = "cancellation";
}
